
 <div class="main-wrapper" *transloco="let t">
    <div class="header">
      <span class="header-text">{{ monthLabel }}</span>
      <div class="buttons-wrapper">
        <button (click)="prevWeek()" [attr.aria-label]="'Decrement Month'" class="button-undecorated arrow-button" [ngClass]="{disabled: !this.hasPreviousWeek()}">
          <cwo-icon class="icon" [name]="arrowIcon"/>
        </button>
        <button (click)="nextWeek()" [attr.aria-label]="'Increment Month'" class="button-undecorated arrow-button" [ngClass]="{disabled: !this.hasNextWeek()}">
          <cwo-icon class="icon right" [name]="arrowIcon"/>
        </button>
      </div>
      
    </div>
    <div class="week">
      <div *ngFor="let day of currentWeek()"  class="day">
        <span class="day-label">{{ getDayName(day.date)}}</span>
        <button class="button-undecorated day-date-button"
          (click)="chooseDate(day)"
          [ngClass]="{
            'selected': selectedDate?.date === day.date,
          }"
        >
          <span class="day-date" [ngClass]="{'closed': day.closed}">{{ getDayOfMonth(day.date) }}</span>
        </button>
      </div>
    </div>
    @if(calendarEvents.length){
      <div class="events-wrapper">
        @for (event of calendarEvents; track $index) {
          <cwo-calendar-event [calendarEvent]="event" />
        }
      </div>
    }
  
    @if(showClosedStoreLabel) {
      <div class="store-closed-announcement">
        <img src="../../../assets/icons/closed_tag.png" [alt]="'Closed'" class="closed-tag">
        <span class="store-closed-label">
          {{t("shared_components.calendar_component.closed_store_message")}}
        </span>
      </div>
    }
  </div>

